import {
    Selection,
    SelectionDirection,
} from "../Controls/Internals/ControlsReexport/CustomControls/CurrencyInput/SelectionHelper";

export function getSelectionFromEvent(input: EventTarget): Selection {
    if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) {
        throw new Error("Control is not HTMLInputElement or HTMLTextAreaElement");
    }
    return {
        start: input?.selectionStart ?? 0,
        end: input?.selectionEnd ?? 0,
        direction: input.selectionDirection as SelectionDirection,
    };
}
